<template>
	<div class="investment-estimate-container">
		<div class="tab-header">
			<button class="tab-btn" :class="{ active: activeTab === 'total' }"
				@click="activeTab = 'total'">总投资</button>
			<button class="tab-btn" :class="{ active: activeTab === 'civil' }"
				@click="activeTab = 'civil'">建筑工程</button>
			<button class="tab-btn" :class="{ active: activeTab === 'equipment' }"
				@click="activeTab = 'equipment'">设备工程</button>
			<button class="tab-btn" :class="{ active: activeTab === 'otherCosts' }"
				@click="activeTab = 'otherCosts'">工程建设其他费用</button>
			<button class="tab-btn" :class="{ active: activeTab === 'workingCapital' }"
				@click="activeTab = 'workingCapital'">流动资金</button>
		</div>

		<div class="tab-content">
			<div v-if="activeTab === 'total'" class="total-table-content">
				<TotalTable />
			</div>

			<!-- 建筑工程内容 -->
			<CivilEngineering v-if="activeTab === 'civil'" ref="civilRef" />

			<!-- 设备工程内容 -->
			<EquipmentEngineering v-if="activeTab === 'equipment'" ref="equipmentRef" />

			<!-- 工程建设其他费用内容 -->
			<OtherConstructionCosts v-if="activeTab === 'otherCosts'" ref="otherCostsRef" />

			<!-- 流动资金内容 -->
			<WorkingCapital v-if="activeTab === 'workingCapital'" ref="workingCapitalRef" />
		</div>
	</div>
</template>

<script>
	import CivilEngineering from './CivilEngineering.vue';
import EquipmentEngineering from './EquipmentEngineering.vue';
import OtherConstructionCosts from './OtherConstructionCosts.vue';
import WorkingCapital from './WorkingCapital.vue';
import TotalTable from './TotalTable.vue';

export default {
	components: {
		CivilEngineering,
		EquipmentEngineering,
		OtherConstructionCosts,
		WorkingCapital,
		TotalTable
	},
		data() {
			return {
				// 当前激活的标签页
				activeTab: 'total'
			}
		},
		methods: {
		}
	}
</script>

<style scoped>
	.investment-estimate-container {
		height: 100%;
		display: flex;
		flex-direction: column;
	}

	/* 标签头部样式 */
	.tab-header {
		display: flex;
		background-color: #f5f7fa;
		border-bottom: 2px solid #409eff;
		margin-bottom: 20px;
	}

	.tab-btn {
		padding: 12px 24px;
		border: none;
		background-color: #f5f7fa;
		color: #606266;
		font-size: 14px;
		cursor: pointer;
		transition: all 0.3s;
		border-radius: 4px 4px 0 0;
		margin-right: 2px;
		border-right: 1px solid #e4e7ed;
	}

	.tab-btn:hover {
		color: #409eff;
		background-color: #ecf5ff;
	}

	.tab-btn.active {
		background-color: #409eff;
		color: #fff;
	}

	.tab-content {
		flex: 1;
		overflow-y: auto;
	}

	.total-table-content {
		background-color: #fff;
		padding: 20px;
		border-radius: 4px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
		min-height: 500px;
		overflow-y: auto;
	}

	.section-title {
		font-size: 18px;
		font-weight: bold;
		margin-bottom: 20px;
		color: #333;
	}

	.component-content {
		background-color: #fff;
		padding: 20px;
		border-radius: 4px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
		height: calc(100% - 50px);
		overflow-y: auto;
	}

	/* 费率输入部分 */
	.rates-section {
		display: flex;
		gap: 40px;
		margin-bottom: 30px;
		padding: 20px;
		background-color: #f9f9f9;
		border-radius: 4px;
	}

	/* 保存按钮部分 */
	.save-section {
		margin-top: 15px;
		text-align: center;
	}

	.save-button {
		padding: 10px 40px;
		background-color: #409eff;
		color: white;
		border: none;
		border-radius: 4px;
		cursor: pointer;
		font-size: 16px;
		font-weight: bold;
		width: 200px;
	}

	.save-button:hover {
		background-color: #66b1ff;
	}

	.save-button:active {
		background-color: #3a8ee6;
	}

	/* 操作列样式 */
	.action-column {
		padding: 8px;
		text-align: center;
	}

	/* 编辑按钮样式 */
	.edit-button {
		padding: 6px 12px;
		background-color: #67c23a;
		color: white;
		border: none;
		border-radius: 4px;
		cursor: pointer;
		font-size: 12px;
		font-weight: bold;
	}

	.edit-button:hover {
		background-color: #85ce61;
	}

	.rate-item {
		display: flex;
		align-items: center;
		gap: 10px;
	}

	.rate-item label {
		font-weight: bold;
		color: #333;
	}

	.rate-item input {
		width: 150px;
		padding: 8px 12px;
		border: 1px solid #dcdfe6;
		border-radius: 4px;
		font-size: 14px;
	}

	.rate-item input:focus {
		outline: none;
		border-color: #409eff;
	}

	.rate-unit {
		color: #606266;
	}

	/* 表格部分 */
	.table-container {
		overflow-x: auto;
	}

	.investment-table {
		width: 100%;
		border-collapse: collapse;
		font-size: 14px;
		table-layout: fixed;
	}

	.table-input {
		width: 100%;
		padding: 5px;
		box-sizing: border-box;
		border: 1px solid #dcdfe6;
		border-radius: 4px;
		font-size: 14px;
		text-align: right;
	}

	.table-input:focus {
		outline: none;
		border-color: #409eff;
	}

	.investment-table th,
	.investment-table td {
		border: 1px solid #e4e7ed;
		padding: 12px 8px;
		text-align: right;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.investment-table th {
		background-color: #f5f7fa;
		font-weight: bold;
		color: #303133;
	}

	/* 列宽设置 */
	.investment-table th:nth-child(1),
	.investment-table td:nth-child(1) {
		width: 50px;
		text-align: center;
	}

	.investment-table th:nth-child(2),
	.investment-table td:nth-child(2) {
		width: 20%;
		text-align: left;
		font-weight: bold;
		color: #333;
	}

	.investment-table th:nth-child(3),
	.investment-table td:nth-child(3) {
		width: 10%;
	}

	.investment-table th:nth-child(4),
	.investment-table td:nth-child(4) {
		width: 10%;
	}

	.investment-table th:nth-child(5),
	.investment-table td:nth-child(5) {
		width: 10%;
	}

	.investment-table th:nth-child(6),
	.investment-table td:nth-child(6) {
		width: 10%;
	}

	.investment-table th:nth-child(7),
	.investment-table td:nth-child(7) {
		width: 10%;
	}

	.investment-table th:nth-child(8),
	.investment-table td:nth-child(8) {
		width: 10%;
	}

	.investment-table th:nth-child(9),
	.investment-table td:nth-child(9) {
		width: 10%;
	}

	.total-column {
		font-weight: bold;
		color: #333;
	}

	/* 行样式 */
	.main-row {
		background-color: #f5f7fa;
	}

	.sub-row {
		background-color: #ffffff;
	}

	.grandsub-row {
		background-color: #f9f9f9;
	}

	/* 响应式设计 */
	@media (max-width: 768px) {
		.rates-section {
			flex-direction: column;
			gap: 20px;
		}
	}
</style>